export function beautify(value: number): string {
  return String(value).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
}
